module.exports = __webpack_public_path__ + "static/unfurl-2d66ed55acf521e7eb6dd034364c3eff.jpg";